import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { SignalRDxpHubConnectionProvider } from './services/providers/signalr-dxp-hub-connection.provider';
import { DXP_HUB_CONNECTION_PROVIDER } from './tokens/realtime.tokens';

/**
 * Registrata nell'injector di radice, e non su una rotta lazy: e' cio' che rende la connessione **una**.
 * Registrata su due feature, ogni feature ne avrebbe la propria istanza, e i canali tornerebbero due.
 */
export function provideRealtime(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: DXP_HUB_CONNECTION_PROVIDER, useClass: SignalRDxpHubConnectionProvider },
  ]);
}
